import { useEffect, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import {
  clearDepositBonusToast,
  getDepositBonusToast,
  getDepositBonusToastVersion,
  subscribeDepositBonusToast,
} from '@/player/deposit-bonus-notifications';
import { Toast } from '@/ui/common/toast';

/**
 * Legacy PNotify for `NewDepoistBonus` after DepositBonusSettings becomes Active.
 */
export function DepositBonusToastHost() {
  const { t } = useTranslation();
  const toastVersion = useSyncExternalStore(
    subscribeDepositBonusToast,
    getDepositBonusToastVersion,
    getDepositBonusToastVersion,
  );
  const toast = toastVersion > 0 ? getDepositBonusToast() : null;

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(() => clearDepositBonusToast(), 4000);
    return () => window.clearTimeout(timer);
  }, [toast?.at, toast?.name]);

  if (!toast) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-16 z-50 flex justify-center px-4">
      <div className="pointer-events-auto w-full max-w-md">
        <Toast tone="success" onDismiss={clearDepositBonusToast}>
          {t('NewDepoistBonus', { defaultValue: 'You have a new deposit bonus!' })}
        </Toast>
      </div>
    </div>
  );
}
